import React, { useState, useEffect, useCallback } from "react";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "../common/common";
import moment from "moment";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import Snackbar from "../snackbar";
import UploadButton from "./UploadButton";
import UploadStatus from "./UploadStatus";
import _ from "lodash";
import ImageCropper from "./ImageCropper";
import CircularProgress from "@mui/material/CircularProgress";

import { Create, Button,useTranslate } from "react-admin";
import { useNavigate } from 'react-router-dom';
import { Backdrop } from "@mui/material";

const DashboardBannerCreate = (props) => {
  // props.location.query.order_number
  const translate = useTranslate();
  const navigate = useNavigate();

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [onSaveDisabled, setOnSaveDisabled] = useState(false);

  const [formSettings, setFormSettings] = useState("");
  // console.log('propssss=>', props.location.query.order_number);

  const [imageToCrop, setImageToCrop] = useState(undefined);
  const [croppedImage, setCroppedImage] = useState(undefined);
  const [bannerStatus, setBannerStatus] = useState(true);
  const [loading, setLoading] = useState(false);
  const [bannerPosition, setBannerPosition] = useState({
    value: "1",
    label: "One",
  });
  const [imageFile, setImageFile] = useState("");
  const [fileDimension, setFileDimension] = useState({
    height: 0,
    width: 0,
  });
  const [fileError, setFileError] = useState(false);
  const [isImageSelected, setIsImageSelected] = useState(false);

  const inputUpdatePhoto = React.useRef(null);
  const [fileExtError, setFileExtError] = useState(false);
  const [sizeError, setSizeError] = useState(false);

  const positionOptions = [
    { value: "1", label: "One" },
    { value: "2", label: "Two" },
    { value: "3", label: "Three" },
    { value: "4", label: "Four" },
    { value: "5", label: "Five" },
    { value: "6", label: "Six" },
    { value: "7", label: "Seven" },
    { value: "8", label: "Eight" },
    { value: "9", label: "Nine" },
    { value: "10", label: "Ten" },
  ];

  const sumbitForm = () => {
    // const splitBusinessId = business[0].id;
    setOnSaveDisabled(true);
    setLoading(true);

    const stateData = localStorage.getItem("__state");
    const userData = stateData ? JSON.parse(stateData) : false;

    const parseBannerPosition = parseInt(bannerPosition.value);

    const formData = new FormData();
    formData.append("image_type", 'web_app');
    formData.append("image_data", imageFile);
    formData.append("position", parseBannerPosition);
    formData.append("status", JSON.stringify(bannerStatus));
    // formData.append('business', splitBusinessId)
    // const targetUrl = `${props.user._links.business.href}/proof_of_payments`;
    // props.addProofOfPay({ targetUrl, formData });
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "POST";

    for (var key of formData.entries()) {
      console.log(key[0] + ", " + key[1]);
    }
    options.body = formData;
    fetch(`${apiUrl}/dashboard_banners`, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: userData._token,
        // "Content-Type": "multipart/form-data",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        console.log(".............", json);
        setOnSaveDisabled(false);
        setLoading(false);
        setShowSnackbar(true);
        setTimeout(() => {
          navigate(-1);
        }, 1000);
      })
      .catch((error) => {
        console.log("error==>", error);
        setLoading(false);
      });
  };

  const changeBannerPosition = (event) => {
    let positionObject = event;
    // let positionObject = positionOptions.find((obj) => obj.value == e.value);
    setBannerPosition(positionObject);
  };

  async function dataUrlToFile(dataUrl, fileName) {
    var arr = dataUrl.split(",");
    var mime = arr[0].match(/:(.*?);/)[1];
    const res = await fetch(dataUrl);
    const blob = await res.blob();
    return new File([blob], fileName, { type: mime });
  }

  const onUploadFile = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      const selectedFile = event.target.files[0];

      const fileExtension = selectedFile.name.substring(
        selectedFile.name.lastIndexOf(".") + 1
      );
      const maxSize = 1;
      const validFileTypes = ["png", "jpg", "jpeg", "PNG", "JPG", "JPEG"];

      if (selectedFile.size / 1024 / 1024 > maxSize) {
        setFileExtError(false);
        setSizeError(true);
        setFileError(false);
        return;
      }

      if (validFileTypes.indexOf(fileExtension) === -1) {
        setSizeError(false);
        setFileExtError(true);
        setFileError(false);
        return;
      }

      setFileExtError(false);
      setSizeError(false);
      setFileError(false);

      const reader = new FileReader();

      reader.onload = function (e) {
        const img = new Image();

        img.onload = function () {
          console.log("img.width, img.height", img.width, img.height);
          
          setFileDimension({
            height: img.height,
            width: img.width,
          });

          const image = reader.result;

          if (img.height === 170 && img.width === 1071) {
            dataUrlToFile(image, `croppedImage.${fileExtension}`).then(
              function (file) {
                setImageFile(file);
                setIsImageSelected(true);
                setCroppedImage(image);
                setImageToCrop(image);
              }
            );
          } else if (img.height < 170 || img.width < 1071) {
            console.log("Image too small - minimum 1071x170 required");
            if (inputUpdatePhoto.current) {
              inputUpdatePhoto.current.value = null;
            }
            setFileError(true);
            setIsImageSelected(false);
            setCroppedImage(undefined);
            setImageToCrop(undefined);
          } else {
            setCroppedImage(undefined);
            setImageToCrop(image);
          }
        };

        img.onerror = function () {
          console.error("Failed to load image");
          setFileError(true);
        };

        img.src = reader.result;
      };

      reader.onerror = function () {
        console.error("Failed to read file");
        setFileError(true);
      };

      reader.readAsDataURL(selectedFile);
    }
  };

  const changeBannerStatus = () => {
    setBannerStatus(!bannerStatus);
  };

  useEffect(() => {
    const formSetting = JSON.parse(localStorage.getItem("__state"));
    setFormSettings(formSetting.proof_of_payment_form);
    setOnSaveDisabled(false);
  }, []);

  // console.log('business id offfffffff', businessId);

  return formSettings ? (
    <Create title={translate('resources.dashboard_banners.fields.create_web_home_banner')} {...props}>
      {/* <SimpleForm redirect="list"> */}
      <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            flexDirection: 'column',
          }}
          open={loading}
        >
          <CircularProgress color="inherit"  />
      </Backdrop>
      <div className={`proof-of-payment-form-page`}>
        <div className="pop-order-number-input">
          <label>
            <span>
            {translate('resources.dashboard_banners.fields.position')}<sup>*</sup>
            </span>
          </label>

          <div className="select-retailer">
            {/* <input
              className="banner-position"
              type="number"
              min="0"
              value={bannerPosition}
              onChange={changeBannerPosition}
            />{" "} */}
            <Select
              options={positionOptions}
              value={bannerPosition}
              onChange={changeBannerPosition}
            />
            {/* <button onClick={cancelAsyncClick}>Clear</button> */}
          </div>
        </div>

        <div className="pop-order-number-input">
          <label>
            <span>{translate('resources.dashboard_banners.fields.status')}</span>
          </label>
          <div
            className={`toggle-button-container ${
              bannerStatus ? "toggle-button-on" : ""
            }`}
          >
            <label className="switch">
              <input
                type="checkbox"
                checked={bannerStatus}
                onChange={changeBannerStatus}
              />{" "}
              <div></div>
            </label>
            <span className="switch-status">{bannerStatus}</span>
          </div>
        </div>

        <div className="pop-order-number-input">
          <label>
            <span>
            {translate('resources.dashboard_banners.fields.banner_img')}<sup>*</sup>
            </span>
          </label>
          <input
            type="file"
            accept=".png, .jpg, .jpeg"
            ref={inputUpdatePhoto}
            onChange={onUploadFile}
          />
          {fileError && (
            <div className="valid-file-upload-error">
              <p>
              {translate('resources.dashboard_banners.fields.banner_select_web')}
              </p>
            </div>
          )}
          {sizeError && (
            <div className="valid-file-upload-error">
              <p>{translate('resources.dashboard_banners.fields.img_size')}</p>
            </div>
          )}
          {fileExtError && (
            <div className="valid-file-upload-error">
              <p>{translate('resources.dashboard_banners.fields.select_image')}</p>
            </div>
          )}
          <div className="valid-file-upload">
            <p>{translate('resources.dashboard_banners.fields.instruction')}</p>
            <ul>
              <li>
              {translate('resources.dashboard_banners.fields.allowed_type')}
              </li>
              <li> {translate('resources.dashboard_banners.fields.max_size')}</li>
              <li>
              {translate('resources.dashboard_banners.fields.image_dim_web')}
              </li>
            </ul>
          </div>
          {(fileDimension.width > 1071 || fileDimension.height > 170) && (
            <div>
              <ImageCropper
                imageToCrop={imageToCrop}
                onImageCropped={(croppedImage) => {
                  setCroppedImage(croppedImage[0]);
                  const newImage = new File(
                    [croppedImage[1]],
                    croppedImage[1].name,
                    { type: croppedImage[1].type }
                  );
                  setImageFile(newImage);
                  setIsImageSelected(true);
                  console.log("---------------", newImage);

                  //convert to base64
                  // var reader = new FileReader();
                  // let imageFile = "";
                  // reader.readAsDataURL(croppedImage[1]);
                  // reader.onloadend = function () {
                  //   setImageFile(reader.result);
                  //   console.log("Base64 String - ", imageFile);
                  // };
                }}
              />
            </div>
          )}
          {(croppedImage ||
            (fileDimension.width == 1071 && fileDimension.height == 170)) && (
            <div>
              <p className="cropped-image-heading">{translate('resources.dashboard_banners.fields.cropped_img')}</p>
              <img alt="Cropped Img" src={croppedImage} />
            </div>
          )}
        </div>

        <div className="so-save-button">
          <button
            onClick={sumbitForm}
            disabled={!isImageSelected || onSaveDisabled}
          >
            <span>{translate('resources.dashboard_banners.fields.save')}</span>
          </button>
        </div>
        {showSnackbar && <Snackbar message="Element Created" />}
      </div>
      {/* </SimpleForm> */}
    </Create>
  ) : (
    <div>{translate('resources.dashboard_banners.fields.loading')}</div>
  );
};

export default DashboardBannerCreate;
